module.exports = __webpack_public_path__ + "fonts/Moderat Bold.ff63f002.otf";